import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { badgeColors, primary, outline, text, white, surface } = colors;
const { borderRadius } = borders;

const bodyFont = '"Hanken Grotesk", "Inter", "Helvetica", "Arial", sans-serif';

const chip = {
  defaultProps: {
    size: "small",
  },
  styleOverrides: {
    root: {
      borderRadius: borderRadius.section,
      fontFamily: bodyFont,
      fontWeight: 600,
      fontSize: pxToRem(13),
      height: pxToRem(32),
      paddingInline: pxToRem(4),
    },
    label: {
      paddingLeft: pxToRem(10),
      paddingRight: pxToRem(10),
      lineHeight: 1.2,
    },
    sizeSmall: {
      height: pxToRem(28),
      fontSize: pxToRem(12),
    },
    outlined: {
      backgroundColor: "transparent",
      borderColor: outline.variant,
      color: text.main,
    },
    filled: {
      border: "1px solid transparent",
    },
    colorPrimary: {
      backgroundColor: badgeColors.info.background,
      color: badgeColors.info.text || primary.main,
    },
    colorSecondary: {
      backgroundColor: surface.container,
      color: text.focus,
      border: `1px solid ${outline.variant}`,
    },
    colorSuccess: {
      backgroundColor: badgeColors.success.background,
      color: badgeColors.success.text,
    },
    colorWarning: {
      backgroundColor: badgeColors.warning.background,
      color: badgeColors.warning.text,
    },
    colorError: {
      backgroundColor: badgeColors.error.background,
      color: badgeColors.error.text,
    },
    colorDefault: {
      backgroundColor: "transparent",
      color: white.main,
      border: `1px solid ${outline.variant}`,
    },
    deleteIcon: {
      color: "inherit",
      opacity: 0.7,
      "&:hover": {
        opacity: 1,
      },
    },
    icon: {
      color: "inherit",
      marginLeft: pxToRem(6),
    },
  },
};

export default chip;
